import React from 'react';
import BaseComponent from './BaseComponent';

class FileUploader extends BaseComponent {

    constructor(props){
	super(props);
    	this.changeFileUploadFields = this.changeFileUploadFields.bind(this);
    	this.sendForm = this.sendForm.bind(this);
    	this.sendFormCallback = this.sendFormCallback.bind(this);

	this.state = {};
	this.form = React.createRef();
    }

    changeFileUploadFields(e){
	const field = e.target;
	
	switch(field.name){
		case "filename":
			this.setState(prevState => {
				return {
				    ...prevState,
				    filename: field.value
				}
			});
		    	break;
		case "fileComments":
			this.setState(prevState => {
				return {
				    ...prevState,
				    comments: field.value
				}
			});
		    	break;
		case "fileupload":
			this.setState(prevState => {
				return {
				    ...prevState,
				    fileupload: field.files[0]
				}
			});
			break;
		default:	
			break;
	}
    }

    sendForm(){

	let formData = new FormData();
	formData.append('fileupload',this.state.fileupload);
	if(this.state.filename !== undefined) formData.append('filename',this.state.filename);
	if(this.state.comments !== undefined) formData.append('comments',this.state.comments);

	if(this.props.aditionalFields){
		this.props.aditionalFields.forEach(field => {
			formData.append(field.name, field.value);
		});
	}

	const api = this.getApi();
	api.uploadFile(formData, this.sendFormCallback);
    }

    sendFormCallback(response){
    	if(this.props.onSendFile) this.props.onSendFile(response);
    }

    render(){
	return (
	<div className="row">
    	 	<div className="col-12">
    			<form ref={this.form}>
				<div className="form-group">
				    <input type="file" className="form-control" id="fileupload" name="fileupload"
				    onChange={this.changeFileUploadFields} style={{border:"0px",paddingLeft:"0px"}} />
				</div>
				<div className="form-group">
				    <label htmlFor="filename">Nombre del fichero</label>
				    <input type="text" className="form-control" id="filename" name="filename"
				    onChange={this.changeFileUploadFields} />
				</div>

				<div className="form-group">
				    <label htmlFor="fileComments">Comentarios</label>
				    <textarea className="form-control" id="fileComments" name="fileComments"
				    onChange={this.changeFileUploadFields} ></textarea>
				</div>
    	 		</form>
	 	</div>
	</div>)
    }

    floatingSquare = {
	width: 'auto',
	marginTop: '-3px',
	minWidth: '203px',
	minHeight: '30px',
	maxHeight: '300px',
	maxWidth: '250px',
	height: 'auto',
	border: '1px solid #CCC',
	position: 'absolute',
	zIndex: '1',
	background: '#FFF',
	marginLeft: '3px',
	padding: '3px 5px',
	listStyleType: 'none',
	display: 'none',
	overflowY: 'auto',
	overflowX: 'hidden',
	textOverflow: 'ellipsis'
    }

    dropButton = {
	width: '25px',
	height: '30px',
	paddingTop: '3px',
	paddingLeft: '7px',
	cursor: 'pointer',
	background: '#007bff',
	color: 'white',
	marginLeft: '-1px',
	display: 'inline-block',

    }
}

export default FileUploader;
